import { CertNaming } from "../mod_browser.js";
export function isPublicSecretKey(obj) {
    return !!obj.publicKey || !!obj.secretKey;
}
export class ImportCertCached {
    ImportedType;
    defaultAlgoList;
    constructor(ImportedType, defaultAlgoList) {
        this.ImportedType = ImportedType;
        this.defaultAlgoList = defaultAlgoList;
    }
    cache = new WeakMap();
    async importCert(cert, { algoList = this.defaultAlgoList, checkValidity = true, now = Date.now(), }) {
        if (checkValidity) {
            cert.checkValidity(now);
        }
        let p = this.cache.get(cert);
        if (!p) {
            const [algo, key] = await cert.importPublicKey(algoList);
            p = new this.ImportedType(CertNaming.toKeyName(cert.name), algo, key);
            this.cache.set(cert, p);
        }
        return p;
    }
}
